import React from "react";
import MenuGrid from "../MenuGrid";

const SECTIONS = [
  {
    title: "Inventario",
    items: [
      { label: "Inventario",            icon: "fas fa-warehouse", href: "/ListadoInventarios",           key: "inventarios.inventario.ver" },
      // { label: "Inventario Desglosado", icon: "fas fa-warehouse", href: "/ListadoInventariosDesglosado", perm: "inventarios" },
      // { label: "Inventario Costos",     icon: "fas fa-warehouse", href: "/ListadoInventariosCostos",     perm: "inventarios" },
      { label: "Traspasos Salida",  icon: "fas fa-sign-out-alt", href: "/ListadoTraspasosSalida",  key: "inventarios.traspasosSalida.ver"  },
      { label: "Traspasos Entrada", icon: "fas fa-sign-in-alt",  href: "/ListadoTraspasosEntrada", key: "inventarios.traspasosEntrada.ver" },
    ],
  },
  {
    title: "Materia Prima",
    items: [
      { label: "Inventario Materia Prima",  icon: "fas fa-warehouse", href: "/ListadoInventariosTelas", key: "inventarios.materiaPrima.ver" },
      { label: "Seguimiento Materia Prima", icon: "fas fa-search",    href: "/ListadoSeguimientoTelas", key: "inventarios.seguimientoMP.ver" },
    ],
  },
  // {
  //   title: "Traspasos",
  //   items: [
  //     { label: "Traspasos Salida",  icon: "fas fa-sign-out-alt", href: "/ListadoTraspasosSalida",  perm: "menu_traspasos_salida"  },
  //     { label: "Traspasos Entrada", icon: "fas fa-sign-in-alt",  href: "/ListadoTraspasosEntrada", perm: "menu_traspasos_entrada" },
  //   ],
  // },
  {
    title: "Seguimiento",
    items: [
      // { label: "Ubicaciones por Artículo", icon: "fas fa-thumbtack",      href: "/ListadoUbicaciones",  perm: "inventarios" },
      // { label: "Ubicaciones",              icon: "fas fa-map-marked-alt", href: "/ListadoUbicaciones2", perm: "inventarios" },
      { label: "Almacenes",                icon: "fas fa-warehouse",      href: "/Areas",               key: "inventarios.almacenes.ver" },
      { label: "Seguimiento",              icon: "fas fa-search",         href: "/ListadoSeguimiento",  key: "inventarios.seguimiento.ver" },
    ],
  },
  {
    title: "Reportes",
    items: [
      { label: "Reporte Mínimos", icon: "fas fa-exclamation-triangle", href: "/ReporteMinimos", key: "inventarios.minimos.ver" },
    ],
  },
];

function BotonesInventarios() {
  return (
    <MenuGrid
      title="Inventarios"
      subtitle="Stock, traspasos, ubicaciones y seguimiento"
      icon="fas fa-warehouse"
      accent={{ color: "#0ea5e9", bg: "#f0f9ff" }}
      modulo="inventarios"
      sections={SECTIONS}
    />
  );
}

export default BotonesInventarios;
